import images from '../../../data/images.json';


import { Box } from "@mui/material";

export default function Header(){
    return(
        <Box
            sx={{
                backgroundColor:'primary.main',
                color:'primary.contrastText',
                height:"200px"
            }}
        >
            <img src={images.logo.browser.src} alt={images.logo.browser.alt} style={{
                marginTop:"25px",
                height:"150px",
                width:'auto'
            }}/>
        </Box>);
}